import qs                            from 'qs';
import fetch                         from '../../../utils/browser-fetch';
import busyActionFactory             from '../../../busy';
import { addError }                  from '../../../errors-dux';
import Errors                        from '../../../errors';
import { setUserData }               from '../../../user-dux';
import { fetchBundleData }           from '../../../client-dux';
import { preActivationLoginAttempt } from '../activation/activation-dux';

/******************
 * Initial state
 */
const initialState = {
    busyFetchingUserData: false,
    clientSite: {
        name: null,
        url: null
    },
    ssoType: 'login_only'
};

/******************
 * Non-async action types
 */
const SET_SSO_CONFIG = 'SET_SSO_CONFIG';
const BUSY_FETCHING_SSO_AUTHENTICATED_USER_DATA = 'BUSY_FETCHING_SSO_AUTHENTICATED_USER_DATA';

/******************
 * Reducer
 */
export default function ssoAuthenticated( state = initialState, action ) {
    switch ( action.type ) {
        case BUSY_FETCHING_SSO_AUTHENTICATED_USER_DATA:
            return {
                ...state,
                busyFetchingUserData: action.busy
            };
        case SET_SSO_CONFIG:
            return {
                ...state,
                ...action.ssoConfig
            };
        default:
            return state;
    }
}

/******************
 * Action creators
 */
export function setSSOConfig( ssoConfig ) {
    return {
        type: SET_SSO_CONFIG,
        ssoConfig
    };
}

const busyFetchingUserData = busyActionFactory( BUSY_FETCHING_SSO_AUTHENTICATED_USER_DATA );
export function fetchSSOAuthenticatedUserData() {
    return dispatch => {
        try {
            // If there is a JSESSIONID in the url then we need to fetch user data from
            // the server, otherwise we get it from sessionStorage
            const query = window ? qs.parse( window.location.search.substr( 1 ) ) : {};
            const sessionIdFromUrl = query.JSESSIONID;
            const error = typeof query.error === 'string';
            const invalid = typeof query.invalid === 'string';
            const preActivationError = query.code === '20013';

            if ( sessionIdFromUrl ) {
                delete query.JSESSIONID;
                fetch.setSessionId( sessionIdFromUrl );
                window.history.replaceState( null, null, '/' );
                dispatch( busyFetchingUserData( true ) );

                return fetch( '/api/v1.0/user', dispatch )
                    .then( userData => {
                        const fetchBundleDataFlag = JSON.parse( sessionStorage.getItem( 'bundleState' ) ).bundleList[ userData.locale ];
                        userData.sessionId = sessionIdFromUrl;

                        if ( !fetchBundleDataFlag ) {
                            dispatch( fetchBundleData( userData.locale.code ) ).then( () => {
                                userData.authenticated = true;
                                dispatch( setUserData( userData ) );
                                dispatch( busyFetchingUserData( false ) );
                            } );
                        } else {
                            userData.authenticated = true;
                            dispatch( setUserData( userData ) );
                            dispatch( busyFetchingUserData( false ) );
                        }
                    } );
            } else if ( invalid ) {
                const err = new Error( 'Invalid SSO credentials' );
                err.localeCode = 'sso.error.invalidCredentials';
                dispatch( addError( err, Errors.ERROR_SSO_AUTHENTICATED_FETCH_PROFILE ) );
            } else if ( preActivationError ) {
                dispatch( preActivationLoginAttempt( true, query.message ) );
            } else if ( error ) {
                const err = new Error( 'SSO authentication error' );
                err.localeCode = 'sso.error.login';
                dispatch( addError( err, Errors.ERROR_SSO_AUTHENTICATED ) );
            } else {
                // The redirect did not have a JSESSIONID, but neither an error nor invalid credentials were indicated
                const errI18n = new Error( 'No session was provided by the server after logging in.' );
                errI18n.localeCode = 'sso.error.noSessionId';
                dispatch( addError( errI18n, Errors.ERROR_SSO_AUTHENTICATED_NO_SESSIONID ) );
            }
        } catch ( err ) {
            err.localeCode = 'sso.error.userData';
            dispatch( addError( err, Errors.ERROR_SSO_AUTHENTICATED_FETCH_PROFILE ) );
            dispatch( busyFetchingUserData( false ) );
        }
    };
}
